var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5019 38.1115V25.0542H30.1063L30.584 20.5546H26.5019L26.5081 18.3025C26.5081 17.1289 26.6196 16.5001 28.3052 16.5001H30.5585V12H26.9536C22.6235 12 21.0995 14.1828 21.0995 17.8536V20.5551H18.4004V25.0547H21.0995V38.1115H26.5019Z",
    fill: "#231C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookwhite);
export default __webpack_public_path__ + "static/media/Facebook white.d381f2b6df47076d5837cd17a0074624.svg";
export { ForwardRef as ReactComponent };